import React from 'react'

const LabelDecs = ({title,text,color}) => {
  return (
    <section className='LabelDecs'>
        <label>{title}</label>
        <label style={{color:color}}>{text}</label>
    </section>
  )
}

export default LabelDecs